import { INotificationsNotificationTypeChoices } from 'graphql/types';

export function getNotificationTypeTranslationKey(
    type: INotificationsNotificationTypeChoices
): string | undefined {
    const baseKey = 'notificationTypes';

    switch (type) {
        case INotificationsNotificationTypeChoices.AssignmentCommented:
            return `${baseKey}.assignmentCommented`;
        case INotificationsNotificationTypeChoices.AssignmentGrade:
            return `${baseKey}.assignmentGrade`;
        case INotificationsNotificationTypeChoices.AssignmentUploaded:
            return `${baseKey}.assignmentUploaded`;
        case INotificationsNotificationTypeChoices.AssignmentUploadState:
            return `${baseKey}.assignmentUploadState`;
        case INotificationsNotificationTypeChoices.CertificateAboutToExpire:
            return `${baseKey}.certificateAboutToExpire`;
        case INotificationsNotificationTypeChoices.CertificateReceived:
            return `${baseKey}.certificateReceived`;
        case INotificationsNotificationTypeChoices.CourseCompleted:
            return `${baseKey}.courseCompleted`;
        case INotificationsNotificationTypeChoices.CourseExportCompleted:
            return `${baseKey}.courseExportCompleted`;
        case INotificationsNotificationTypeChoices.DevelopmentPlanCommented:
            return `${baseKey}.developmentPlanCommented`;
        case INotificationsNotificationTypeChoices.OfferEnrolled:
            return `${baseKey}.offerEnrolled`;
        case INotificationsNotificationTypeChoices.OfferEnrollmentRequested:
            return `${baseKey}.offerEnrollmentRequested`;
        case INotificationsNotificationTypeChoices.OfferEnrollmentWaitingListUserAdded:
            return `${baseKey}.offerEnrollmentWaitingListUserAdded`;
        case INotificationsNotificationTypeChoices.OfferEventNew:
            return `${baseKey}.offerEventNew`;
        case INotificationsNotificationTypeChoices.OfferEventRegistrationClosed:
            return `${baseKey}.offerEventRegistrationClosed`;
        case INotificationsNotificationTypeChoices.OfferEventRegistrationClosedMinNotReached:
            return `${baseKey}.offerEventRegistrationClosedMinNotReached`;
        case INotificationsNotificationTypeChoices.OfferEventRegistrationClosedMinReached:
            return `${baseKey}.offerEventRegistrationClosedMinReached`;
        case INotificationsNotificationTypeChoices.ReportExportCompleted:
            return `${baseKey}.reportExportCompleted`;
        case INotificationsNotificationTypeChoices.UserExportCompleted:
            return `${baseKey}.userExportCompleted`;
        case INotificationsNotificationTypeChoices.OfferEventDateUpdated:
            return `${baseKey}.offerEventDateUpdated`;
        case INotificationsNotificationTypeChoices.OfferEventDateDeleted:
            return `${baseKey}.offerEventDateDeleted`;
        case INotificationsNotificationTypeChoices.OfferEventDateAdded:
            return `${baseKey}.offerEventDateAdded`;
        case INotificationsNotificationTypeChoices.EnrollmentExportCompleted:
            return `${baseKey}.enrollmentExportCompleted`;
        case INotificationsNotificationTypeChoices.PrivateChatUnreadMessage:
            return `${baseKey}.privateChatUnreadMessage`;
        case INotificationsNotificationTypeChoices.TrainingChatUnreadMessage:
            return `${baseKey}.trainingChatUnreadMessage`;
        case INotificationsNotificationTypeChoices.GroupChatUnreadMessage:
            return `${baseKey}.groupChatUnreadMessage`;
        case INotificationsNotificationTypeChoices.UserCreatedExternalReceivedCertificate:
            return `${baseKey}.userCreatedExternalReceivedCertificate`;
        case INotificationsNotificationTypeChoices.ReceivedCertificateValidationStatusChanged:
            return `${baseKey}.receivedCertificateValidationStatusChanged`;
        case INotificationsNotificationTypeChoices.UserImportFinished:
            return `${baseKey}.userImportFinished`;
        case INotificationsNotificationTypeChoices.SkillGroupBelowMinimum:
            return `${baseKey}.skillGroupBelowMinimum`;
    }
}
